import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class GiftBumperHoliday24Widget extends Widget {
	componentWillMount() {
		window.tpm_gb = this;

		const dismissed = getCookie("tpm_dismiss_gift_bumper");
		if (dismissed) this.state.dismissed = true;
		this.toggleDismiss = this.toggleDismiss.bind(this);
		this.closeForever = this.closeForever.bind(this);
		this.remindLater = this.remindLater.bind(this);
	}

	toggleDismiss(e) {
		e.preventDefault();
		this.setState({
			dismissIntent: !this.state.dismissIntent,
		});
	}

	closeForever() {
		setCookie("tpm_dismiss_gift_bumper", 1, 30);
		this.setState({
			dismissed: true,
		});
	}

	remindLater() {
		setCookie("tpm_dismiss_gift_bumper", 1, 1);
		this.setState({
			dismissed: true,
		});
	}

	renderContent() {
		if (this.state.dismissed) return;

		if (this.state.dismissIntent) {
			return (
				<div className="GiftBanner --slim --intent-dismiss">
					<div class="GiftBanner__Dismiss --back" onClick={this.toggleDismiss}>
						BACK
					</div>
					<div class="GiftBanner__DontSee">Don't want to see this message?</div>
					<div class="GiftBanner__DismissButtons">
						<div
							onClick={this.remindLater}
							class="GiftBanner__DismissButton Button --navy-border-white"
						>
							REMIND ME LATER
						</div>
						<div
							onClick={this.closeForever}
							class="GiftBanner__DismissButton Button --navy-border-white"
						>
							NOT INTERESTED
						</div>
					</div>
				</div>
			);
		}

		return (
			<div class="GiftBanner --slim">
				<a class="GiftBanner__Text" href="https://talkingpointsmemo.com/gifts">
					<div class=" GiftBanner__PreHead">Back By Popular Demand</div>
					<div class="GiftBanner__Head">Give the Gift&nbsp;of&nbsp;TPM</div>
				</a>
				<div class="GiftBanner__Button">
					<a
						class="Button --red-border-white"
						href="https://talkingpointsmemo.com/gifts"
					>
						GIVE TPM
					</a>
				</div>
				<div class="GiftBanner__Dismiss" onClick={this.toggleDismiss}>
					<i class="fa-sharp fa-light fa-xmark"></i>
				</div>
			</div>
		);
	}
}
